/* src/app/shared/components/flow-helper-text/flow-helper-text.component.scss */
:host {
  display: block;
}
.flow-helper-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  color: #71717a;
}
.flow-helper-text__left {
  display: flex;
  align-items: center;
  gap: 4px;
}
.flow-helper-text__icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: inherit;
}
.flow-helper-text__icon img {
  width: 16px;
  height: 16px;
  filter: brightness(0) saturate(100%) invert(45%) sepia(10%) saturate(279%) hue-rotate(202deg) brightness(95%) contrast(85%);
}
.flow-helper-text__text {
  color: inherit;
}
.flow-helper-text__count {
  color: inherit;
  flex-shrink: 0;
  margin-left: auto;
}
.flow-helper-text--success {
  color: #16a34a;
}
.flow-helper-text--success .flow-helper-text__icon img {
  filter: brightness(0) saturate(100%) invert(37%) sepia(90%) saturate(5201%) hue-rotate(137deg) brightness(111%) contrast(83%);
}
.flow-helper-text--destructive,
.flow-helper-text--flash {
  color: #b91c1c;
}
.flow-helper-text--destructive .flow-helper-text__icon img,
.flow-helper-text--flash .flow-helper-text__icon img {
  filter: brightness(0) saturate(100%) invert(27%) sepia(57%) saturate(2736%) hue-rotate(341deg) brightness(74%) contrast(108%);
}
/*# sourceMappingURL=flow-helper-text.component.css.map */
